module.exports = __webpack_public_path__ + "static/image141-9379507455c506d0e34f0a7e98df2c62.jpg";